/**
 * Prefijos para registro; Perú primero, resto ordenados alfabéticamente (es).
 */
const EXTRA = [
  { code: 'AR', name: 'Argentina', dial: '+54' },
  { code: 'BO', name: 'Bolivia', dial: '+591' },
  { code: 'BR', name: 'Brasil', dial: '+55' },
  { code: 'CA', name: 'Canadá', dial: '+1' },
  { code: 'CL', name: 'Chile', dial: '+56' },
  { code: 'CO', name: 'Colombia', dial: '+57' },
  { code: 'CR', name: 'Costa Rica', dial: '+506' },
  { code: 'EC', name: 'Ecuador', dial: '+593' },
  { code: 'SV', name: 'El Salvador', dial: '+503' },
  { code: 'ES', name: 'España', dial: '+34' },
  { code: 'US', name: 'Estados Unidos', dial: '+1' },
  { code: 'FR', name: 'Francia', dial: '+33' },
  { code: 'GT', name: 'Guatemala', dial: '+502' },
  { code: 'IT', name: 'Italia', dial: '+39' },
  { code: 'MX', name: 'México', dial: '+52' },
  { code: 'PA', name: 'Panamá', dial: '+507' },
  { code: 'PY', name: 'Paraguay', dial: '+595' },
  { code: 'PT', name: 'Portugal', dial: '+351' },
  { code: 'GB', name: 'Reino Unido', dial: '+44' },
  { code: 'UY', name: 'Uruguay', dial: '+598' },
  { code: 'VE', name: 'Venezuela', dial: '+58' },
];

const PE = { code: 'PE', name: 'Perú', dial: '+51' };

const sorted = [...EXTRA].sort((a, b) =>
  a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })
);

export const PHONE_COUNTRIES = [PE, ...sorted];

export const DEFAULT_PHONE_DIAL = '+51';

/** Emoji de bandera a partir del código ISO (ej. PE → 🇵🇪). */
export function countryCodeToFlag(iso2) {
  const code = String(iso2 || '').toUpperCase();
  if (!/^[A-Z]{2}$/.test(code)) return '🌐';
  const base = 0x1f1e6;
  const letterA = 'A'.charCodeAt(0);
  return String.fromCodePoint(
    ...[...code].map((ch) => base + ch.charCodeAt(0) - letterA)
  );
}

export function formatPhoneCountryOption(c, { compact = false } = {}) {
  const flag = countryCodeToFlag(c.code);
  if (compact) return `${flag} ${c.dial}`;
  return `${flag} ${c.name} (${c.dial})`;
}
